import React from 'react';
import ManageCustomers from '../screens/customers/ManageCustomers';
import AddCustomer from '../screens/customers/AddCustomer';
import ManageApplications from '../screens/application/ManageApplications';
import AddApplication from '../screens/application/AddApplication';
import ManageRoles from '../screens/roles/ManageRoles';
import AddRole from '../screens/roles/AddRole';
import ManageProjects from '../screens/project/ManageProjects';
import ManageUsers from '../screens/user/ManageUsers';
import AddProject from '../screens/project/AddProject';
import AddUser from '../screens/user/AddUser';
import { userRoleEnums } from '../hooks/custom-hooks/useAuthHook';
import { LoginSettings } from '../screens/settings/LoginSettings';
import { SendNotification } from '../screens/notification/SendNotification';

export const RouteEnums = {
  // Customer Routes
  CUSTOMER: '/customers',
  CUSTOMER_ADD: '/customers/add',
  CUSTOMER_EDIT: '/customers/edit',

  // Application Routes
  APPLICATION: '/applications',
  APPLICATION_ADD: '/applications/add',
  APPLICATION_EDIT: '/applications/edit',

  // User Role Routes
  USER_ROLE: '/user-roles',
  USER_ROLE_ADD: '/user-roles/add',
  USER_ROLE_EDIT: '/user-roles/edit',

  // Project Routes
  PROJECT: '/projects',
  PROJECT_ADD: '/projects/add',
  PROJECT_EDIT: '/projects/edit',

  // User Routes
  USER: '/users',
  USER_ADD: '/users/add',
  USER_EDIT: '/users/edit',

  // Login setting

  LOGIN_SETTING: '/login-setting',
  SEND_NOTIFICATION: '/send-notification',
};

export const RouteConstants = [
  {
    path: RouteEnums.CUSTOMER,
    child: [
      { path: '', element: <ManageCustomers /> },
      { path: 'add', element: <AddCustomer /> },
      { path: `edit/:customerId`, element: <AddCustomer /> },
    ],
  },
  {
    path: RouteEnums.APPLICATION,
    child: [
      { path: '', element: <ManageApplications /> },
      { path: 'add', element: <AddApplication /> },
      { path: `edit/:applicationId`, element: <AddApplication /> },
    ],
  },
  {
    path: RouteEnums.USER_ROLE,
    child: [
      { path: '', element: <ManageRoles /> },
      { path: 'add', element: <AddRole /> },
      { path: `edit/:roleId`, element: <AddRole /> },
    ],
  },
  {
    path: RouteEnums.PROJECT,
    child: [
      { path: '', element: <ManageProjects /> },
      { path: 'add', element: <AddProject /> },
      { path: `edit/:projectId`, element: <AddProject /> },
    ],
  },
  {
    path: RouteEnums.USER,
    child: [
      { path: '', element: <ManageUsers />, allowedRoles: [userRoleEnums.CUSTOMER_ADMIN] },
      { path: 'add', element: <AddUser />, allowedRoles: [userRoleEnums.CUSTOMER_ADMIN] },
      { path: `edit/:userId`, element: <AddUser />, allowedRoles: [userRoleEnums.CUSTOMER_ADMIN] },
    ],
  },
  {
    path: RouteEnums.LOGIN_SETTING,
    element: <LoginSettings />,
  },
  {
    path: RouteEnums.SEND_NOTIFICATION,
    element: <SendNotification />,
  },
];
